import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const workflowSectionStatus_slice = createSlice({
  name: "workflowSectionStatus",
  initialState,
  reducers: {
    set_workflowSectionStatus: (state, action) => {
      return action.payload;
    },
    reset_workflowSectionStatus: () => initialState,
  },
});

export const { set_workflowSectionStatus, reset_workflowSectionStatus } =
  workflowSectionStatus_slice.actions;

export default workflowSectionStatus_slice.reducer;
